import type {
  ProductLineCatalog,
  ProductLineTemplate,
} from './product-settings.types';

const optin = (newId: number): Record<string, ProductLineTemplate> => ({
  vouchers: {
    id: newId,
    enabled: true,
    new: true,
    title: 'ID-' + newId,
    voucherCode: '',
    voucherCodeFootnote: '',
    currencySymbol: '&euro;',
    value: '',
    voucherType: 'name',
    conditions: [],
    trackingOptions: [],
    voucherUptainExclusive: true
  },
  fomo: {
    id: newId,
    enabled: true,
    new: true,
    title: 'ID-' + newId,
    conditions: [],
    trackingOptions: [],
  },
});

const mail = (newId: number): Record<string, ProductLineTemplate> => ({
  vouchers: {
    id: newId,
    enabled: true,
    new: true,
    title: 'ID-'+newId,
    voucherCode: '',
    voucherCodeFootnote: '',
    currencySymbol: '&euro;',
    value: '',
    voucherType: 'name',
    conditions: [],
    voucherUptainExclusive: true
  },
  shoppingcart: {
    id: newId,
    enabled: true,
    new: true,
    title: 'ID-'+newId,
    conditions: [],
  },
  links: {
    id: newId,
    enabled: true,
    new: true,
    title: 'ID-'+newId,
    conditions: [],
  },
  custom: {
    id: newId,
    enabled: true,
    new: true,
    title: 'ID-'+newId,
    type: 2,
    language: 'de',
    productId: 1,
    html: '',
    plain: '',
    activationTemplateRef: '',
    subject: '',
    conditions: [],
  },
});

const activation = (newId: number): Record<string, ProductLineTemplate> => ({
  vouchers: {
    id: newId,
    enabled: true,
    new: true,
    title: 'ID-'+newId,
    voucherCode: '',
    voucherCodeFootnote: '',
    currencySymbol: '&euro;',
    value: '',
    voucherType: 'name',
    conditions: [],
    trackingOptions: [],
    voucherUptainExclusive: true
  },
  activemails: {
    id: newId,
    enabled: true,
    new: true,
    title: 'ID-'+newId,
    contactPerson: '',
    serviceCategory: '',
    email: '',
    conditions: [],
    trackingOptions: [],
  },
  passivemails: {
    id: newId,
    enabled: true,
    new: true,
    title: 'ID-'+newId,
    mailAddress: '',
    mailSubject: '',
    mailContent: '',
    conditions: [],
    trackingOptions: [],
  },
  phonenumbers: {
    id: newId,
    enabled: true,
    new: true,
    title: 'ID-'+newId,
    phoneNumber: '',
    // availability: '',
    phoneNumberFootnote: '',
    conditions: [],
    trackingOptions: [],
  },
  callbacks: {
    id: newId,
    enabled: true,
    new: true,
    title: 'ID-'+newId,
    availability: '',
    conditions: [],
    trackingOptions: [],
  },
  shoppingcart: {
    id: newId,
    enabled: true,
    new: true,
    title: 'ID-'+newId,
    conditions: [],
    trackingOptions: [],
  },
  links: {
    id: newId,
    enabled: true,
    new: true,
    title: 'ID-'+newId,
    linkTitle: '',
    linkURL: '',
    linkTarget: '_self',
    heading: '',
    subtitle: '',
    subtitleSecondLine: '',
    footnote: '',
    conditions: [],
    trackingOptions: [],
  },
  custom: {
    id: newId,
    enabled: true,
    new: true,
    title: 'ID-'+newId,
    regainType: '',
    activationWindow: ['', ''],
    mobileTrigger: [],
    desktopTrigger: [],
    fallbackTrigger: [],
    exitTimeout: '',
    blockDurationMinutes: '',
    conditions: [],
    trackingOptions: [],
  },
});


const productLines = (newId: number): ProductLineCatalog => ({
  optin: optin(newId),
  mail: mail(newId),
  activation: activation(newId),
});

export default productLines;
